import { useEffect } from 'react';
import { activateForms, deactivateForms, openForm } from "./controller";
export var useZendeskForms = function useZendeskForms(_ref) {
  var applicationId = _ref.applicationId,
    email = _ref.email;
  useEffect(function () {
    if (applicationId && email) {
      activateForms({
        email: email,
        applicationId: applicationId
      });
    }
    return function () {
      deactivateForms();
    };
  }, [applicationId, email]);
  return {
    openForm: openForm
  };
};